export default [
    {
        path: 'relatorio-agendador',
        component: () => import(
            /* webpackChunkName: 'transporte-paciente-relatorio-agendador' */
            '@/views/transporte-paciente/relatorio-agendador/Index'
        ),
        redirect: 'relatorio-agendador/index',
        children: [
            {
                name: 'transporte-paciente-relatorio-agendador-index',
                path: 'index',
                component: () => import(
                    /* webpackChunkName: 'transporte-paciente-relatorio-agendador' */
                    '@/views/transporte-paciente/relatorio-agendador/List.vue'
                ),
            },
        ],
    },
]
